import React, { useState } from 'react';
import { Calendar, Select, Row, Col, Badge } from 'antd';
import dayjs from 'dayjs';
import styles from './engagementCalendar.module.scss';
import { KoTooltips } from 'packages';

const { Option } = Select;

// ✅ Structured Event Data
const calendarEvents = [
  {
    label: 'Sprint Review',
    activityType: 'Webinar',
    color: '#52c41a',
    date: 12
  },
  {
    label: 'Retrospective',
    activityType: 'Meeting',
    color: '#fa8c16',
    date: 24
  },
  {
    label: 'Planning Session',
    activityType: 'Workshop',
    color: '#1890ff',
    date: 26
  }
];

// ✅ Return matching event(s) for the date
const getListData = (value) => {
  return calendarEvents.filter(event => event.date === value.date());
};

// ✅ Render cell with badge, tooltip, color
const dateFullCellRender = (value) => {
  const listData = getListData(value);
  const isEvent = listData.length > 0;
  const event = listData[0]; // assuming 1 event per day

  const cellContent = (
    <div className={`${styles.calendarCell} ${isEvent ? styles.active : ''}`}>
      <div>{value.date()}</div>
    </div>
  );

  return isEvent ? (
    <KoTooltips title={`${event.label} (${event.activityType})`}>
      <Badge dot={true} status="processing" size="large" style={{ backgroundColor: event.color }}>
        {cellContent}
      </Badge>
    </KoTooltips>
  ) : (
    cellContent
  );
};

const EngagementCalendar = ({onChange}) => {
  const [value, setValue] = useState(dayjs());

  const onPanelChange = (newValue) => {
    setValue(newValue);
    onChange(newValue);
  };

  const headerRender = ({ value, onChange }) => {
    const currentYear = value.year();
    const currentMonth = value.month();

    const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);
    const months = Array.from({ length: 12 }, (_, i) => i);

    return (
      <Row justify="end" gutter={8} style={{ padding: 8 }} >
        <Col>
          <Select
            size="small"
            value={currentYear}
            onChange={(year) => {
              const newDate = value.year(year);
              onChange(newDate);
              onPanelChange(newDate);
            }}
          >
            {years.map((year) => (
              <Option key={year} value={year}>
                {year}
              </Option>
            ))}
          </Select>
        </Col>
        <Col>
          <Select
            value={currentMonth}
            size="small"
            onChange={(month) => {
              const newDate = value.month(month);
              onChange(newDate);
              onPanelChange(newDate);
            }}
          >
            {months.map((month) => (
              <Option key={month} value={month}>
                {dayjs().month(month).format('MMMM')}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
    );
  };

  return (
    <Calendar
      className='calendarEngagement'
      fullscreen={false}
      value={value}
      onPanelChange={onPanelChange}
      dateFullCellRender={dateFullCellRender}
      headerRender={headerRender}
    />
  );
};

export default EngagementCalendar;
